module.exports = __webpack_public_path__ + "static/media/3.bacba50d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/3.jpg
// module id = 1676
// module chunks = 0 1